export { useMachine } from "@xstate/vue";
export {
  createMachine,
  assign as xstateAssign,
  fromPromise as xstateFromPromise,
} from "xstate";

export function getStateValueStrings(stateValue: unknown): string[] {
  if (typeof stateValue === "string") return [stateValue];

  if (typeof stateValue === "object" && stateValue !== null) {
    const valueKeys = Object.keys(stateValue);

    return [
      ...valueKeys,
      ...valueKeys.flatMap((key) =>
        getStateValueStrings(stateValue[key as keyof typeof stateValue]!).map(
          (s) => key + "." + s,
        ),
      ),
    ];
  }

  return [];
}

const WizardUtilitiesInjectionKey = Symbol("Wizard state injection key");

/*
That Hook is only used to handle back cta automatically in Wizard steps
without having to enable it manually for each step.
 */

export type WizardUtilities<Event = { type: string }> = {
  send(event: Event): void;
  state: Ref<{ can(event: Event): boolean }>;
};

export function useWizardUtilities<Event>() {
  return inject<WizardUtilities<Event>>(WizardUtilitiesInjectionKey);
}

export function provideWizardUtilities(utilities: WizardUtilities) {
  provide(WizardUtilitiesInjectionKey, utilities);
}
